/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AutoEndpoint,
  AutoEndpoint$inboundSchema,
  AutoEndpoint$outboundSchema,
} from "./autoendpoint.js";

export type DeleteOrgAutoModelResponse = {
  endpoint: AutoEndpoint;
  cleared: true;
};

/** @internal */
export const DeleteOrgAutoModelResponse$inboundSchema: z.ZodType<
  DeleteOrgAutoModelResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  endpoint: AutoEndpoint$inboundSchema,
  cleared: z.literal(true),
});
/** @internal */
export type DeleteOrgAutoModelResponse$Outbound = {
  endpoint: string;
  cleared: true;
};

/** @internal */
export const DeleteOrgAutoModelResponse$outboundSchema: z.ZodType<
  DeleteOrgAutoModelResponse$Outbound,
  z.ZodTypeDef,
  DeleteOrgAutoModelResponse
> = z.object({
  endpoint: AutoEndpoint$outboundSchema,
  cleared: z.literal(true),
});

export function deleteOrgAutoModelResponseToJSON(
  deleteOrgAutoModelResponse: DeleteOrgAutoModelResponse,
): string {
  return JSON.stringify(
    DeleteOrgAutoModelResponse$outboundSchema.parse(deleteOrgAutoModelResponse),
  );
}
export function deleteOrgAutoModelResponseFromJSON(
  jsonString: string,
): SafeParseResult<DeleteOrgAutoModelResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteOrgAutoModelResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteOrgAutoModelResponse' from JSON`,
  );
}
